import * as React from 'react'
import styled from 'styled-components'
import { Box, get, Space, TextHeading } from '@ally/metronome-ui'
import { AdobeTile, AdobeTileContent } from '../../../types'
import LgTile from './LgTile'

interface LgTileGroupProps {
  data: AdobeTileContent
}

const StyledBox = styled(Box)`
  border: 1px dashed ${get.colors('slate-3')};
  border-radius: 4px;
`

const LgTileGroup: React.FC<LgTileGroupProps> = ({
  data,
}): React.ReactElement => {
  // Limit tiles to render to 3
  const tiles = data.tiles.slice(0, 3)

  return (
    <>
      {tiles.map((tileData: AdobeTile, index) => {
        const tileDataKey = `explore-tile-${index}`
        return (
          <Box key={tileDataKey}>
            <Space mt="xs" mb="xs">
              <TextHeading tag="h4" size="xs">
                {tileData.title}
              </TextHeading>
            </Space>
            <StyledBox
              display="flex"
              flexDirection="row"
              alignItems="center"
              justifyContent="space-between"
              padding="sm"
              width="100%"
            >
              <LgTile tileData={tileData} />
            </StyledBox>
          </Box>
        )
      })}
    </>
  )
}

export default LgTileGroup
